import React, { useState, useRef, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import "./styles.scss";

// Remove react-icons imports

const ClassCardOptions = ({ options, classId, classData, additionalParam }) => {
  const [show, setShow] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShow(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Handle showing/hiding dropdown
  const toggleDropdown = (e) => {
    if (Object.keys(e).length) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShow(!show);
  };

  // Handle option click
  const handleOptionClick = (e, handler) => {
    e.preventDefault();
    e.stopPropagation();
    setShow(false);
    handler(classId, additionalParam);
  };

  // Custom class based on option type (replacing icons)
  const getOptionClass = (optionText) => {
    if (typeof optionText === "function") {
      const text = optionText(classData);
      if (text === "Resume") return "resume-option";
      if (text === "Suspend") return "suspend-option";
    }

    switch (optionText) {
      case "Edit":
        return "edit-option";
      case "Delete":
        return "delete-option";
      case "Share":
        return "share-option";
      case "Reschedule":
        return "reschedule-option";
      default:
        return "";
    }
  };

  if (!options || options.length === 0) {
    return null;
  }

  return (
    <Dropdown
      className="class-card-options"
      ref={dropdownRef}
      show={show}
      onToggle={toggleDropdown}
    >
      <Dropdown.Toggle as="div" className="options-toggle-container">
        <button
          className="options-toggle-btn"
          onClick={toggleDropdown}
          aria-expanded={show}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5Z"
              fill="currentColor"
            />
            <path
              d="M3 9.5C3.82843 9.5 4.5 8.82843 4.5 8C4.5 7.17157 3.82843 6.5 3 6.5C2.17157 6.5 1.5 7.17157 1.5 8C1.5 8.82843 2.17157 9.5 3 9.5Z"
              fill="currentColor"
            />
            <path
              d="M13 9.5C13.8284 9.5 14.5 8.82843 14.5 8C14.5 7.17157 13.8284 6.5 13 6.5C12.1716 6.5 11.5 7.17157 11.5 8C11.5 8.82843 12.1716 9.5 13 9.5Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </Dropdown.Toggle>

      <Dropdown.Menu className="options-menu" align="end">
        {options.map((option, index) => {
          const optionText =
            typeof option.text === "function"
              ? option.text(classData)
              : option.text;

          return (
            <Dropdown.Item
              key={index}
              className={`options-item ${getOptionClass(option.text)}`}
              onClick={(e) => handleOptionClick(e, option.actionsHandler)}
            >
              {optionText}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ClassCardOptions;
